import axios from "axios";
 const apiUrl = "https://registrationsapi.jdmplates.co.uk";
//const apiUrl = "http://localhost:8080";

const baseUrl = `${apiUrl}/api/v1`;

const apiRequest = axios.create({ baseURL: baseUrl });

export { apiUrl, baseUrl, apiRequest };
